import itsystemsPropertiesProvider from './itsystemsPropertiesProvider';

export default {
  __init__: [ 'itsystemsPropertiesProvider' ],
  itsystemsPropertiesProvider: [ 'type', itsystemsPropertiesProvider ]
};